import { Injectable } from '@angular/core';
import { AnagraficaClassificheService } from './anagrafica-classifiche.service';
import { AnagraficaIndirizziService } from './anagrafica-indirizzi.service';
import { AnagraficaPrecedenzeService } from './anagrafica-precedenze.service';
import { AnagraficaQualificheService } from './anagrafica-qualifiche.service';
import { AnagraficaSezioniService } from './anagrafica-sezione.service';
import { AnagraficaStatiService } from './anagrafica-stati.service';
import { AnagraficaUtentiService } from './anagrafica-utenti.service';

@Injectable({
  providedIn: 'root'
})
export class AnagraficheService {
  constructor(
    public classifiche: AnagraficaClassificheService,
    public indirizzi: AnagraficaIndirizziService,
    public precedenze: AnagraficaPrecedenzeService,
    public qualifiche: AnagraficaQualificheService,
    public sezioni: AnagraficaSezioniService,
    public stati: AnagraficaStatiService,
    public utenti: AnagraficaUtentiService
  ) { }
}
